/**
 * Generates a random CUID (Collision-resistant Unique IDentifier)
 * @returns A random CUID string
 */
export const generateRandomId = (): string => {
  const timestamp = Date.now().toString(36);
  const random = Math.random().toString(36).substring(2);
  return `${timestamp}-${random}`;
};
